import { render } from "./App.vue?vue&type=template&id=752d426c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=752d426c&lang=css"

import exportComponent from "/home/frog/Documents/vue/FEVO/fevo_site/fevo_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__